import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import axios from "axios";
import AllPagesNavbar from "./Navbar";
import Loading from "./Loading";
import { BiSolidEditAlt } from "react-icons/bi";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from "exceljs";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";
import moment from "moment";
function TrainingSchedule() {
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;

  const authToken = window.sessionStorage.getItem("auth-token");
  const sclientSecret = window.sessionStorage.getItem("sclientSecret");
  const [search, setSearch] = useState("");
  const [isloading, setisloading] = useState(false);
  const userState = useSelector((state) => state.getUserState);
  const userLoggeduserCode = userState.user.userCode;
  const [sheduleNumber, setSheduleNumber] = useState(0);
  const [latestScheduleNo, setLatestScheduleNo] = useState(0);
  const [TrainingDays, setTrainingDays] = useState(0);
  const [TrainingType, setTrainingType] = useState([]);
  const [sheludeDate, setSheludeDate] = useState("");
  const [employeeCode, setEmployeeCode] = useState("");
  const [listofEmployee, setlistofEmployee] = useState([]);
  const [SelectedValueType, setSelectedValueType] = useState("");
  const [SelectedValueDays, setSelectedValueDays] = useState(0);
  const [selectedEmployees, setSelectedEmployees] = useState([]); // New state to track selected employees
  const [histData, setHistData] = useState([]);
  const [showHist, setShowHist] = useState(false);
  const [searchHist, setSearchHist] = useState("");
  const [deletePopUp, setDeletePopup] = useState("");
  const [reasonToDelete, setReasonToDelete] = useState("");
  const currentDate = new Date();
  const [toDateFilter, setToDateFilter] = useState(
    currentDate?.toISOString()?.split("T")[0],
  );

  console.log(SelectedValueType)
  // Filter Journeys
  const filterJourney = histData?.filter((item) => {
    const searchData = searchHist?.toLowerCase()?.split(" ").filter(Boolean);

    if (searchHist.length === 0) {
      return true;
    }
    const textMatch = searchData.every((term) =>
      ["SCHEDULENO", "EMPPLOYEEMNAME", "TRAININGTYPE"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      }),
    );

    return textMatch;
  });

  useEffect(() => {
    FetchDetails();
  }, []);

  function FetchDetails() {
    setisloading(true);
    axios
      // .get(`${BASEURL}/getNewTrainingSchedule`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=477`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((res) => {
        setisloading(false);
        setSheduleNumber(res.data[0]?.NEWSHEDULENO);
        setLatestScheduleNo(res.data[0]?.NEWSHEDULENO);
      })
      .catch((err) => {
        setisloading(false);
        console.log("Error while fetching /getEngines List", err);
      });
    axios
      // .get(`${BASEURL}/getallemployee`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=349`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((response) => {
        console.log(response.data);
        setlistofEmployee(response.data);
      })
      .catch((err) => {
        setisloading(false);
        console.log("Error while fetching /getEngines List", err);
      });

    axios
      // .get(`${BASEURL}/getTrainingScheduleDeatils`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=540`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((res) => {
        setHistData(res?.data);
        console.log(res.data);
      })
      .catch((err) => {
        setisloading(false);
        console.log("Error while fetching /getEngines List", err);
      });

    axios
      // .get(`${BASEURL}/getTrainingTypes`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=542`, {
        headers: {
          "auth-token": authToken,
          "session-token": sclientSecret,
        },
      })
      .then((response) => {
        setTrainingType(response.data);
      })
      .catch((err) => {
        setisloading(false);
        console.log("Error while fetching /getEngines List", err);
      });
  }

  function handleselected(e) {
    setSelectedValueType(e.value);
    const days = TrainingType.map((item) => {
      if (item.TRAININGTYPE === e.value) {
        return item.TRAININGDAYS;
      }
      return null; // Add this to handle map return when no match
    }).filter(Boolean); // Filter out null values
    setSelectedValueDays(days[0]);
  }

  const handleCheckboxChange = (item, isChecked) => {
    if (isChecked) {
      setSelectedEmployees((prev) => {
        if (!prev.find((employee) => employee.EMPID === item.EMPID)) {
          return [...prev, item];
        }
        return prev;
      });
    } else {
      setSelectedEmployees(
        (prev) => prev.filter((employee) => employee.EMPID !== item.EMPID), // Remove if unchecked
      );
    }
  };

  console.log(selectedEmployees);
  const selectEmployeeByEmpId = (empId) => {
    const employee = listofEmployee.find((emp) => emp.EMPID === empId);

    console.log(employee);
    if (!employee) return;

    setSelectedEmployees((prev) => {
      const alreadySelected = prev.some((emp) => emp.EMPID === empId);
      console.log(alreadySelected);
      if (alreadySelected) return prev;

      return [...prev, employee];
    });
  };

  console.log(selectedEmployees); // This should show only the checked employees

  const filteredData = listofEmployee.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    const textMatch = searchData.every((term) => {
      return ["EMPCODE", "EMPNAME", "EMAIL", "DEPARTMENT", "DESIGNATION"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    return textMatch;
  });

  const HandleSave = async () => {
    if (selectedEmployees.length === 0) {
      alert("Please select at least one employee");
      return;
    }
    if (!SelectedValueType) {
      alert("Please select training type");
      return;
    }
    if (!SelectedValueDays) {
      alert("Please provide TRAINING DAYS");
      return;
    }

    if (!toDateFilter) {
      alert("Please provide SHEDULE DATE");
      return;
    }

    const confirmEdit = window.confirm("Are you sure you want to Save?");
    if (confirmEdit) {
      setisloading(true);
      const date = toDateFilter ? toDateFilter.slice(0, 10) : "";
      try {
        const requests = selectedEmployees.map((employee) => {
          console.log(employee.EMPID);
          const dataToSend = {
            TRAININGSCHEDULENO: sheduleNumber,
            TRAININGTYPE: SelectedValueType,
            EMPID: employee.EMPID,
            TRAININGDAYS: SelectedValueDays,
            SHEDULEDATE: toDateFilter?.slice(0, 10),
            SCHEDULECREATEDBY: userLoggeduserCode,
            SUCCESS_STATUS: "",
            ERROR_STATUS: "",
          };

          return axios.post(
            // `${BASEURL}/insertTrainingSchedule`,
            `${BASEURL_GLOBAL}/globalSpHandler?spname=24 `,

            dataToSend,
            {
              headers: {
                "auth-token": authToken,
                "session-token": sclientSecret,
              },
            },
          );
        });

        await Promise.all(requests); // Wait for all requests to complete
        alert("Training schedules saved successfully!");
        window.location.reload(); // Refresh the page after successful save
      } catch (error) {
        console.error("Error while saving training schedules:", error);
        alert("An error occurred while saving the training schedules.");
      }
    }
  };

  // DELETE

  const HandleDelete = async () => {
    const confirmEdit = window.confirm("Are you sure you want to Delete?");
    if (confirmEdit) {
      setisloading(true);
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1340`,
          {
            TRAININGSCHEDULENO: sheduleNumber,
            PROCESSEDBY: userLoggeduserCode,
            PROCESSEDREASON: reasonToDelete,
            SUCCESS_STATUS: "",
            ERROR_STATUS: "",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sclientSecret,
            },
          },
        );

        if (response.status === 201) {
          alert("Training Schedule Deleted Successfully");
          window.location.reload();
        } else {
          alert("Error while Deleting Training Schedule");
        }
      } catch (err) {
        console.log("Error while Deleting Training Schedule", err);
        alert("Error while Deleting Training Schedule");
        setisloading(false);
      }
    }
  };

  const scrollToSection = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleGeneratePDF = () => {
    const doc = new jsPDF();

    // Add Title
    doc.setFontSize(18);
    doc.text("Training Schedule Report", 105, 10, { align: "center" });

    // Add the header information
    const headers = [
      { label: "TRAINING SCHEDULE NO:", value: sheduleNumber || "N/A" },
      { label: "TRAINING TYPE:", value: SelectedValueType || "N/A" },
      { label: "TRAINING DAYS:", value: SelectedValueDays || "N/A" },
      { label: "SHEDULE DATE:", value: toDateFilter || "N/A" },
    ];

    headers.forEach((header, index) => {
      doc.setFontSize(12);
      doc.text(`${header.label} ${header.value}`, 20, 20 + index * 10);
    });

    // Add a gap before the table
    const startY = 20 + headers.length * 10 + 10;

    // Add the employee table
    const tableColumnHeaders = [
      "EMP CODE",
      "EMP NAME",
      "EMAIL",
      "DESIGNATION",
      "DEPARTMENT",
    ];

    const tableRows = selectedEmployees.map((item) => [
      item.EMPCODE || "N/A",
      item.EMPNAME || "N/A",
      item.EMAIL || "N/A",
      item.DESIGNATION || "N/A",
      item.DEPARTMENT || "N/A",
    ]);

    // Add the table to the PDF
    doc.autoTable({
      head: [tableColumnHeaders],
      body: tableRows,
      theme: "grid",
      headStyles: { fillColor: [22, 160, 133] }, // Optional styling
      margin: { top: startY },
      styles: {
        halign: "center", // Center align text in columns
      },
    });

    // Save the PDF
    doc.save("Selected_Training_Schedule.pdf");
  };

  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Training Schedule Report");

    // Set column widths
    const columnWidths = [25, 25, 40, 25, 25];
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers for the report (Schedule No, Training Type, etc.)
    worksheet.addRow(["Training Schedule Report"]).font = {
      bold: true,
      size: 16,
    };
    worksheet.mergeCells("A1:E1");

    worksheet.addRow([]);
    worksheet.addRow(["Training Schedule No:", sheduleNumber || "N/A"]);
    worksheet.addRow(["Training Type:", SelectedValueType || "N/A"]);
    worksheet.addRow(["Training Days:", SelectedValueDays || "N/A"]);
    worksheet.addRow(["Schedule Date:", toDateFilter || "N/A"]);

    worksheet.addRow([]); // Empty row to separate the header from the table

    // Add the employee table headers
    const tableHeaders = [
      "EMP CODE",
      "EMP NAME",
      "EMAIL",
      "DESIGNATION",
      "DEPARTMENT",
    ];
    worksheet.addRow(tableHeaders).font = { bold: true };

    // Add selected employee data rows
    selectedEmployees.forEach((item) => {
      worksheet.addRow([
        item.EMPCODE || "N/A",
        item.EMPNAME || "N/A",
        item.EMAIL || "N/A",
        item.DESIGNATION || "N/A",
        item.DEPARTMENT || "N/A",
      ]);
    });

    // Create and download the Excel file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Training_Schedule_Report.xlsx";
      link.click();
    });
  };

  if (isloading) {
    return <Loading />;
  }

  return (
    <div className="bg-gray-50 min-h-[100vh] newpages__input">
      <AllPagesNavbar />
      <header className="header__of__main lg:flex justify-between items-end px-3">
        <h1 className="header__of__page">{menu || "Engine Master"}</h1>
        <div className="lg:flex items-center gap-5 my-1">
          <button
            onClick={() => {
              window.location.reload();
            }}
            className="border-l-indigo-900 rounded mx-2 text-white"
          >
            New
          </button>
          <button
            onClick={HandleSave}
            className="border-l-indigo-900 rounded mx-2 text-white"
          >
            Save
          </button>

          <button
            onClick={() => {
              if (latestScheduleNo === sheduleNumber) {
                alert("Kindly Choose Saved Schedules to Delete");
              } else {
                setDeletePopup(true);
              }
            }}
            className="border-l-indigo-900 rounded mx-2 text-white"
          >
            Delete
          </button>

          {deletePopUp && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[200px] h-[80%] lg:w-[500px] w-[95%] p-1 overflow-y-auto">
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2">Reason :</p>
                <textarea
                  className="w-64 resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  rows={3}
                  value={reasonToDelete}
                  onChange={(e) => {
                    setReasonToDelete(e.target.value);
                  }}
                ></textarea>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setDeletePopup(false)}
              >
                Close
              </button>
              <div className="lg:flex mt-2 items-center justify-center">
                <button
                  className="border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={async () => {
                    if (reasonToDelete) {
                      await HandleDelete();
                    } else {
                      alert("Kindly Provide Reason To Delete");
                    }
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          )}

          <div
            onClick={handleGeneratePDF}
            className="border-l-indigo-900 rounded mx-2 text-blue-950 cursor-pointer"
          >
            <BsFileEarmarkPdf size={35} />
          </div>
          <div
            onClick={ExcelStockData}
            className="border-l-indigo-900 rounded mx-2 text-blue-950 cursor-pointer"
          >
            <RiFileExcel2Line size={35} />
          </div>
        </div>
      </header>
      <aside className="m-5">
        <section className="lg:flex  gap-10">
          <div>
            <p>TRAINING SCHEDULE NO</p>
            <div className="flex">

            <input
              type="text"
              className="h-9 px-1 text-right"
              value={sheduleNumber}
              readOnly
              />
          <button
            className="flex mx-1 lg:mt-2 h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
            onClick={() => setShowHist(true)}
            >
            ...
          </button>
              </div>
            </div>

          {showHist && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto z-[500]">
              <div className="lg:flex lg:flex-row mt-2">
                <p className="text-red-600 lg:ml-2">Search:</p>
                <input
                  className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={searchHist}
                  onChange={(e) => setSearchHist(e.target.value)}
                ></input>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowHist(false)}
              >
                Close
              </button>
              <div className="overflow-y-auto h-[500px]">
                <table className="custom-table text-sm overflow__y__ relative ">
                  <thead
                    className="header-cell sticky top-[0px] left-[10px]"
                    style={{ zIndex: 50 }}
                  >
                    <tr>
                      <td>TRAINING SCHEDULE NO</td>
                      <td>STATUS DATE</td>
                      <td>EMPLOYEE NAME</td>
                      <td>TRAINING TYPE</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filterJourney.map((row, index) => (
                      <tr
                        className="border-b text-[12px] cursor-pointer"
                        key={index}
                        onClick={() => {
                          setSheduleNumber(row.SCHEDULENO);
                          setToDateFilter(row.STATUSDATETIME?.split("T")[0]);
                          setSelectedValueType(row.TRAININGTYPE);
                          const days = TrainingType.map((item) => {
                            if (item.TRAININGTYPE === row.TRAININGTYPE) {
                              return item.TRAININGDAYS;
                            }
                            return null; // Add this to handle map return when no match
                          }).filter(Boolean); // Filter out null values
                          setSelectedValueDays(days[0]);
                          selectEmployeeByEmpId(row.EMPID);
                          setShowHist(false);
                        }}
                      >
                        <td className="text-right">
                          {row.SCHEDULENO ? row.SCHEDULENO : "N/A"}
                        </td>
                        <td>
                          {row.STATUSDATETIME
                            ? moment(row.STATUSDATETIME).format("DD/MM/YYYY")
                            : "N/A"}
                        </td>
                        <td>
                          {row.EMPPLOYEEMNAME ? row.EMPPLOYEEMNAME : "N/A"}
                        </td>
                        <td>{row.TRAININGTYPE ? row.TRAININGTYPE : "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div>
            <p>TRAINING TYPE</p>
            <Select
              className="input_field text-left uppercase z-[100]"
              onChange={handleselected}
              value={
                SelectedValueType
                  ? { label: SelectedValueType, value: SelectedValueType }
                  : { label: "", value: "" }
              }
              // options={[{ value: "", label: "" }].concat(
              //   TrainingType.map((item) => ({
              //     label: item.TRAININGTYPE,
              //     value: item.TRAININGTYPE,
              //   })),
              // )}
              options={[
                { value: "", label: " " },
                ...TrainingType?.map((item) => ({
                  value: item?.TRAININGTYPE,
                  label: item?.TRAININGTYPE,
                })),
              ]}
            ></Select>
          </div>
          <div>
            <p>TRAINING DAYS</p>
            <input
              type="number"
              className="h-9 px-1"
              value={SelectedValueDays}
              readOnly
            />
          </div>
          <div>
            <p>SHEDULE DATE</p>
            <input
              type="date"
              className="h-9 px-1"
              value={toDateFilter}
              onChange={(e) => setToDateFilter(e.target.value)}
            />
          </div>
        </section>
      </aside>
      <div className="z-10 lg:flex  flex-col w-full">
        <div>
          <div className="lg:flex mx-6">
            <p className="w-[70px]">Search:</p>
            <input
              className="w-[300px] h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="overflow-y-auto h-[500px] px-4">
            <table className="custom-table  overflow__y__ relative text-[12px] ">
              <thead
                className="header-cell sticky top-[0px] left-[10px]"
                style={{ zIndex: 50 }}
              >
                <tr>
                  <td></td>
                  <td className="">
                    <p>EMP CODE</p>
                  </td>
                  <td className="">EMPNAME </td>
                  <td className="">EMAIL</td>
                  <td className="">DESIGNATION</td>
                  <td className="">DEPARTMENT</td>
                  {/* <td className="w-[120px]">EDIT</td> */}
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 &&
                  filteredData.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        textTransform: "uppercase",
                        cursor: "pointer",
                      }}
                    >
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedEmployees.some(
                            (emp) => emp.EMPID === item.EMPID,
                          )}
                          onChange={(e) =>
                            handleCheckboxChange(item, e.target.checked)
                          }
                          className="w-[20px]"
                        ></input>
                      </td>
                      <td className="">
                        {item.EMPCODE ? item.EMPCODE : "N/A"}
                      </td>
                      <td className="">
                        {item.EMPNAME ? item.EMPNAME : "N/A"}
                      </td>
                      <td>{item.EMAIL ? item?.EMAIL : "N/A"}</td>
                      <td>{item?.DESIGNATION ? item?.DESIGNATION : "N/A"}</td>
                      <td>{item?.DEPARTMENT ? item?.DEPARTMENT : "N/A"}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrainingSchedule;
